import * as React from 'react';

const SVGArrowDown: React.SFC<SvgProps> = props => (
  <svg width={13} height={14} {...props}>
    <g fill="#9E3667" fillRule="nonzero">
      <path d="M11.455 3.719a.75.75 0 0 1 1.5 0v8.562a.75.75 0 0 1-.75.75h-8.41a.75.75 0 1 1 0-1.5h7.66V3.719z" />
      <path d="M12.162 11.101a.75.75 0 1 1-1.06 1.06L.97 2.032A.75.75 0 0 1 2.03.97L12.162 11.1z" />
    </g>
  </svg>
);

export default SVGArrowDown;
